import { HealthUnit } from "@/@types/esus/HealthUnit";
import { appApi } from "../api";
import { Paginated } from "@/@types/generics/paginated";
import { ModuleEnum } from "@/utils/enums/ModuleEnum";

type GetUnitsParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
	module?: ModuleEnum;
};

type GetUnitsPaginatedParams = {
	uf: string | null;
	ibgeCode: string;
	cnes?: string;
	pageNumber: number;
	name?: string;
	module?: ModuleEnum;
};

export async function getHealthUnits(params: GetUnitsParams) {
	const { data } = await appApi.get<HealthUnit[]>(`/healthunit`, params);
	return data || [];
}

export async function getUnitsPaginated(params: GetUnitsPaginatedParams) {
	const { data } = await appApi.get<Paginated<HealthUnit>>(`/healthunit/paginated`, params);
	return data || ({} as Paginated<HealthUnit>);
}

export async function updateCityHealthUnits(uf: string, ibgeCode: string) {
	const response = await appApi.post<number>(`/HealthUnit/update-all`, { uf, ibgeCode });
	if (response.status === 200) {
		const numberOfHealthUnitsAdded = response.data || 0;
		return numberOfHealthUnitsAdded;
	}
}
